import { useState, useEffect } from 'react';
import { getLeaderboard } from '../../services/achievements';
import { useAuth } from '../../context/AuthContext';
import { Trophy, Medal } from 'lucide-react';

export default function Leaderboard() {
  const { user } = useAuth();
  const [leaders, setLeaders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getLeaderboard().then(r => setLeaders(r.data.leaderboard)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="flex items-center justify-center h-64"><div className="animate-spin rounded-full h-8 w-8 border-2 border-blue-500 border-t-transparent"></div></div>;

  const medalColors = ['text-yellow-500', 'text-gray-400', 'text-amber-600'];

  return (
    <div className="max-w-3xl mx-auto space-y-6">
      <div className="bg-gradient-to-r from-yellow-500 to-orange-500 rounded-2xl p-8 text-white text-center">
        <h1 className="text-3xl font-bold mb-2 flex items-center justify-center gap-2"><Trophy className="w-8 h-8" /> Reyting jadvali</h1>
        <p className="text-yellow-100">Eng faol talabalar reytingi</p>
      </div>

      <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
        {leaders.map((u, i) => (
          <div key={u.id} className={`flex items-center gap-4 p-4 ${i < leaders.length - 1 ? 'border-b border-gray-100' : ''} ${u.id === user?.id ? 'bg-blue-50' : ''}`}>
            <div className="w-8 text-center text-lg font-bold text-gray-400">
              {i < 3 ? <Medal className={`w-6 h-6 ${medalColors[i]}`} /> : <span className="text-sm">{i + 1}</span>}
            </div>
            <div className="w-10 h-10 rounded-full bg-gradient-to-r from-blue-500 to-purple-600 flex items-center justify-center text-white font-bold">
              {u.avatar_url ? <img src={u.avatar_url} className="w-full h-full rounded-full object-cover" /> : u.name?.charAt(0)?.toUpperCase()}
            </div>
            <div className="flex-1">
              <p className="font-semibold text-gray-900">{u.name} {u.id === user?.id && <span className="text-xs text-blue-600">(siz)</span>}</p>
              <p className="text-xs text-gray-500">Daraja {u.level}</p>
            </div>
            <div className="text-right">
              <span className="text-lg font-bold text-blue-600">{u.xp_points}</span>
              <span className="text-xs text-gray-500 ml-1">XP</span>
            </div>
          </div>
        ))}
        {leaders.length === 0 && (
          <div className="p-12 text-center text-gray-500">Hali reyting shakllanmagan</div>
        )}
      </div>
    </div>
  );
}